const photoSortFn = (photo1, photo2) => photo1.sortOrder - photo2.sortOrder;

export const getSortedPhotos = (selectedSkuId, prevPhotos) => {
    let sortedPhotos = null;
    const selectedSkuPhotos = [];
    const productPhotos = [];
    const remainingSkuPhotos = [];
    // Use this for looking up selected sku photos quickly
    const selectedSkuPhotosObj = {};

    prevPhotos.forEach(_photo => {
        const xrefs = _photo.imageSkuXrefs || [];
        if (xrefs.some(_skuXref => _skuXref.skuId === selectedSkuId)) {
            selectedSkuPhotosObj[_photo.serviceId] = _photo;
            selectedSkuPhotos.push(_photo);
        }
    });

    // If the selected sku has no photos, we'll just return previous photos
    // We don't want to call graphql each time the selected sku changes, so
    // re-implement the logic from graphql taking the selected sku into account
    if (selectedSkuPhotos.length) {
        prevPhotos.forEach(_photo => {
            const xrefs = _photo.imageSkuXrefs || [];
            // Ignore selectedSkuPhotos, since we already have those
            if (!selectedSkuPhotosObj[_photo.serviceId]) {
                if (xrefs.length === 0) {
                    // if no xrefs this is a base item photo
                    productPhotos.push(_photo);
                } else {
                    // all else are remaining sku images
                    remainingSkuPhotos.push(_photo);
                }
            }
        });

        // sort each array by base sort
        selectedSkuPhotos.sort(photoSortFn);
        productPhotos.sort(photoSortFn);
        remainingSkuPhotos.sort(photoSortFn);
        sortedPhotos = [...selectedSkuPhotos, ...productPhotos, ...remainingSkuPhotos];
    }

    return sortedPhotos || prevPhotos;
};
